import { WarehouseWorkingCenterModelType } from '@teinor/erp/types/company/warehouse/warehouseWorkingCenter'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { LittleModalCreateEdit } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { dictionaryComplexFromJsonArr } from '../../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getWarehouses } from '../../../../../../../../../../utils/reducers/getters'

interface ModalCEWarehouseWorkingCenterProps extends ModalEditComponentProps {}
const ModalCEWarehouseWorkingCenter: React.FC<ModalCEWarehouseWorkingCenterProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { dictWarehouses, id, selectedWarehouses } = useModalCEWarehouseWorkingCenterLogic()
    const fields: FormRender<WarehouseWorkingCenterModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'WarehouseId',
                    label: t('warehouse', 'Almacén'),
                    component: 'CustomSelectSearchBarWithNotInFilteredItems',
                    items: dictWarehouses,
                    excludeItems: selectedWarehouses,
                    required: true
                },
                {
                    name: 'is_main',
                    label: t('byDefault', 'Por defecto'),
                    component: 'Checkbox'
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: id
                }
            ],
        },
    ]
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/workingCenter/workingCenterWarehouse/assignWorkingCenterToWarehouse'} translations={{
        title: t('createWarehouseWorkingCenter', 'Crear almacén de este Centro de trabajo'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

const useModalCEWarehouseWorkingCenterLogic = () => {
    const [selectedWarehouses, setSelectedWarehouses] = useState<string[]>([])
    const dictWarehouses = useMemo(() => dictionaryComplexFromJsonArr(getWarehouses() || []), []) 
    const { id } = useParams()
    const getSelectedWarehouses = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/workingCenter/workingCenterWarehouse/getAllWarehousesOfWorkingCenter', { where: { 'WorkingCenterId': id }})
        const selected: string[] = []
        for (const selectedWarehouse of result) {
            selected.push(String(selectedWarehouse.id))
        }
        setSelectedWarehouses(selected)
    }, [setSelectedWarehouses, id])

    useEffect(() => {
        getSelectedWarehouses()
    }, [getSelectedWarehouses])

    return { dictWarehouses, id, selectedWarehouses }
}

export default ModalCEWarehouseWorkingCenter;